/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import KeyboardArrowLeftOutlined from '@material-ui/icons/KeyboardArrowLeftOutlined';
import React from 'react';
import { MyPageType } from './types';

export type MyPageNavigationProps = {
  currentPage: MyPageType;
  onNavigate: (page: MyPageType) => void;
  primaryColor: string;
  isMyPageTop: boolean;
};

export const MyPageNavigation: React.FC<MyPageNavigationProps> = ({
  currentPage,
  onNavigate,
  primaryColor,
  isMyPageTop,
}) => {
  const styles = getStyles(isMyPageTop, primaryColor);

  const renderTopPage = () => (
    <div
      key="top"
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      `}
    >
      <span css={styles.topTitle}>マイページトップ</span>
      <div
        css={styles.menuItem}
        onClick={() => {
          onNavigate('tickets');
        }}
      >
        <div css={styles.menuItemWithIcon}>
          <ConfirmationNumberOutlinedIcon css={styles.MenuItemIcon} />
          <span css={styles.navButtonText}>チケット</span>
        </div>
      </div>
    </div>
  );

  const renderTicketsPage = () => (
    <div
      key="tickets"
      onClick={() => {
        onNavigate('top');
      }}
      css={styles.menuItemWithArrow}
    >
      <KeyboardArrowLeftOutlined css={styles.backButton} />
      <span css={styles.navItem}>利用可能チケット</span>
    </div>
  );

  const renderTicketDetailPage = () => (
    <div
      key="ticket-detail"
      onClick={() => {
        onNavigate('tickets');
      }}
      css={styles.menuItemWithArrow}
    >
      <KeyboardArrowLeftOutlined css={styles.backButton} />
      <span css={styles.navItem}>チケット詳細</span>
    </div>
  );

  const renderBreadcrumb = () => {
    switch (currentPage) {
      case 'top':
        return renderTopPage();
      case 'tickets':
        return renderTicketsPage();
      case 'ticket-detail':
        return renderTicketDetailPage();
      default:
        return null;
    }
  };
  return <nav css={styles.navigation}>{renderBreadcrumb()}</nav>;
};

const getStyles = (isMyPageTop: boolean, primaryColor: string) => ({
  navigation: css`
    display: flex;
    align-items: center;
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    background-color: ${isMyPageTop ? `${primaryColor}` : 'transparent'};
  `,
  topTitle: css`
    text-decoration: none;
    cursor: pointer;
    color: ${isMyPageTop ? 'white' : '#333'};
    font-size: 16px;
  `,
  navItem: css`
    text-decoration: none;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    &:hover {
      color: #666};
    }
  `,
  separator: css`
    color: #999;
  `,
  backButton: css`
    position: absolute;
    left: 0;
    color: #bababa;
    font-size: 24px;
    &.MuiSvgIcon-root {
      font-size: 24px;
    }
  `,
  menuItem: css`
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  menuItemWithIcon: css`
    font-weight: bold;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &:hover {
      color: #666;
    }
  `,
  menuItemWithArrow: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: #333;
    cursor: pointer;
    position: relative;
    &:hover {
      color: #666;
    }
  `,
  MenuItemIcon: css`
    font-size: 20px;
    color: white;
  `,
  navButtonText: css`
    font-size: 8px;
    line-height: 1.4;
    text-decoration: none;
    color: white;
  `,
  menuArrow: css`
    color: #999;
    font-size: 18px;
  `,
});
